<div *ngIf="sellerFriendlyName">
    <div class="backdrop" (click)="closeModalEmitter()"></div>
    <div class="close-modal" (click)="closeModalEmitter()">X</div>
    <div [innerHtml]="htmlContent" class="modal-right"></div>
</div>

